// extracted by mini-css-extract-plugin
export default {"input":"passwordInput_input__I+oap","label":"passwordInput_label__Po7G5","labelTop":"passwordInput_labelTop__CBj8J","inputSuffix":"passwordInput_inputSuffix__i5fyx"};